export default "__VITE_ASSET__mHzUBwZV__"